import * as z from "zod";
import { WeightSchema } from "../outbound-labels/util";
import { FulfillmentGroupDataSchema } from "./fulfillment-group";
import { FulfillmentOrderLineItemSchema } from "./fulfillment-order-line-item";

export const BatchSuggestionSchema = z.object({
  batchKey: z.string(),
  totalItemCount: z.number(),
  items: z.array(FulfillmentOrderLineItemSchema),
  lineItemsPerOrder: z.number(),
  weightPerOrder: WeightSchema,
  totalShipments: z.number(),
});
export type BatchSuggestion = z.infer<typeof BatchSuggestionSchema>;

export const BatchSuggestionWithGroupsSchema = BatchSuggestionSchema.extend({
  fulfillmentGroups: z.array(FulfillmentGroupDataSchema).nullish(),
});
export type BatchSuggestionWithGroups = z.infer<
  typeof BatchSuggestionWithGroupsSchema
>;
